export const findSubstring = (parent: string, child: string): boolean => {
  if (!parent) return false;
  if (!child) return true;
  return parent.toString().toLowerCase().trim().includes(child.toString().toLowerCase().trim());
};

export const findSubstringInArray = (parent: string, array: string[]): boolean => {
  if (!parent) return false;
  if (!array.length) return true;
  return array.some((item) => findSubstring(parent, item));
};
